module.exports = __webpack_public_path__ + "static/media/greyhoundracing.4503a069.svg";